import { gql, TypedDocumentNode } from "@apollo/client";

import {
  MutationUserRoleBindingBatchCreateArgs,
  MutationUserRoleBindingUpdateArgs,
  Role,
  Space,
  UserRoleBinding,
} from "types/generated";

type UserRoleBindingBatchCreateData = {
  userRoleBindingBatchCreate: Pick<UserRoleBinding, "id">[];
};

export const USER_ROLE_BINDING_BATCH_CREATE: TypedDocumentNode<
  UserRoleBindingBatchCreateData,
  MutationUserRoleBindingBatchCreateArgs
> = gql`
  mutation UserRoleBindingBatchCreate($input: UserRoleBindingBatchInput!) {
    userRoleBindingBatchCreate(input: $input) {
      id
    }
  }
`;

type UserRoleBindingUpdateData = {
  userRoleBindingUpdate: Pick<UserRoleBinding, "id">;
};

export const USER_ROLE_BINDING_UPDATE: TypedDocumentNode<
  UserRoleBindingUpdateData,
  MutationUserRoleBindingUpdateArgs
> = gql`
  mutation UserRoleBindingUpdate($id: ID!, $input: UserRoleBindingInput!) {
    userRoleBindingUpdate(id: $id, input: $input) {
      id
    }
  }
`;

type UserRoleBindingsData = {
  managedUser: {
    id: string;
    userRoleBindings: Array<
      Pick<UserRoleBinding, "id" | "userID"> & {
        space: Pick<Space, "id" | "name">;
        role: Pick<Role, "id">;
      }
    >;
  };
  roles: Pick<Role, "id" | "name">[];
};

export const USER_ROLE_BINDINGS_WITH_ROLES: TypedDocumentNode<UserRoleBindingsData> = gql`
  query UserRoleBindingsWithRoles($id: ID!) {
    managedUser(id: $id) {
      id
      userRoleBindings {
        id
        space {
          id
          name
        }
        userID
        role {
          id
        }
      }
    }
    roles {
      id
      name
    }
  }
`;
